<template>
    <section id="wrapper" class="d-flex justify-content-center align-items-center py-5">
        <div class="col-xs-12 col-sm-12 col-md-8 col-lg-7">
            <section id="main">
                <section id="content" class="page-content card card-block p-4 shadow">
                    <section class="contact-form text-center">
                        <!-- Map -->
                        <h4 class="title_block mb-3">Our Location</h4>
                        <div class="mb-4">
                            <!-- <iframe width="100%" height="350" style="border:0; border-radius: 8px;" loading="lazy"
                                allowfullscreen referrerpolicy="no-referrer-when-downgrade"
                                src="https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_API_KEY&q=23.765628910945264,90.36083590658902&zoom=15">
                            </iframe> -->
                            <GoogleMap
                                ref="myMap"
                                api-key="AIzaSyDofnc8Y4cdPXBff3HFvk3yDCpAHo-idl4"
                                style="width: 100%; height: 500px"
                                :center="center"
                                :zoom="20"
                            >
                                <!-- <InfoWindow :options="{ position: { lat: center.lat, lng: center.lng }, content: '4/A, Shop No. 21 Mehbub Plaza, Indira Rd, Dhaka 1215, Bangladesh' }" /> -->
                                <Marker :options="markerOptions" />
                            </GoogleMap>
                        </div>

                        <!-- Contact Form -->
                        <form ref="contactForm" @submit.prevent="sendEmail" class="text-start">
                            <section class="form-fields container">
                                <!-- Title + Subtitle -->
                                <div class="row mb-4">
                                    <div class="col-md-12 text-center" style="padding-left: 0 !important;">
                                        <h3 class="title_block">Drop Us a Line</h3>
                                        <p class="sub-widget-title">
                                            Have a question or comment? Use the form below to send us a message or
                                            contact us by mail
                                        </p>
                                    </div>
                                </div>

                                <!-- Subject + Email -->
                                <div class="row">
                                    <div class="form-group col-md-6 col-sm-12 mb-3">
                                        <input v-model="fullName" name="name" class="form-control" type="text"
                                            placeholder="Your Name" />
                                        <span class="text-danger small" v-if="errorMessage.fullName">{{
                                            errorMessage.fullName }}</span>
                                    </div>

                                    <div class="form-group col-md-6 col-sm-12 mb-3">
                                        <input v-model="email" name="email" class="form-control" type="email"
                                            placeholder="your@email.com" />
                                        <span class="text-danger small" v-if="errorMessage.email">{{ errorMessage.email
                                            }}</span>
                                    </div>
                                    <div class="form-group col-lg-12 col-md-12 col-sm-12 mb-3" style="padding-left: 0 !important;">
                                        <input v-model="subject" name="title" class="form-control" type="text"
                                            placeholder="Subject Title" />
                                        <span class="text-danger small" v-if="errorMessage.subject">{{
                                            errorMessage.subject }}</span>
                                    </div>

                                    <div class="form-group col-lg-12 col-md-12 col-sm-12 mb-3" style="padding-left: 0 !important;">
                                        <textarea v-model="description" name="message"  class="form-control"
                                            placeholder="How can we help?" rows="5"></textarea>
                                        <span class="text-danger small" v-if="errorMessage.description">{{
                                            errorMessage.description }}</span>
                                    </div>
                                </div>

                                <!-- Submit -->
                                <div class="row text-center">
                                    <div class="form-group col-md-12" style="padding-left: 0 !important;">
                                        <button class="btn btn-primary px-4" type="submit">
                                            <span v-if="!showSpinner">Submit</span>
                                            <span v-else>Sending...</span>
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </form>

                        <!-- <form @submit.prevent="sendEmail" class="text-start">
              <section class="form-fields">
                <h3 class="title_block text-center">Drop Us a Line</h3>
                <p class="sub-widget-title text-center mb-4">
                  Have a question or comment? Use the form below to send us a message or contact us by mail
                </p>

                <div class="form-group mb-3">
                  <select v-model="subject" class="form-control">
                    <option value="">Select Subject</option>
                    <option value="Customer service">Customer service</option>
                    <option value="Webmaster">Webmaster</option>
                  </select>
                  <span class="text-danger small" v-if="errorMessage.subject">{{ errorMessage.subject }}</span>
                </div>

                <div class="form-group mb-3">
                  <input
                    v-model="email"
                    class="form-control"
                    type="email"
                    placeholder="your@email.com"
                  />
                  <span class="text-danger small" v-if="errorMessage.email">{{ errorMessage.email }}</span>
                </div>

                <div class="form-group mb-3">
                  <input
                    v-model="fullName"
                    class="form-control"
                    type="text"
                    placeholder="Your Name"
                  />
                  <span class="text-danger small" v-if="errorMessage.fullName">{{ errorMessage.fullName }}</span>
                </div>

                <div class="form-group mb-3">
                  <input type="file" @change="onFileChange" />
                  <span class="form-control-comment small text-muted">optional</span>
                </div>

                <div class="form-group mb-4">
                  <textarea
                    v-model="description"
                    class="form-control"
                    placeholder="How can we help?"
                    rows="4"
                  ></textarea>
                  <span class="text-danger small" v-if="errorMessage.description">{{ errorMessage.description }}</span>
                </div>
              </section>

              <footer class="form-footer text-center">
                <button class="btn btn-primary px-4" type="submit">
                  <span v-if="!showSpinner">Post Comment</span>
                  <span v-else>Sending...</span>
                </button>
              </footer>
            </form> -->
                    </section>
                </section>
            </section>
        </div>
    </section>
</template>

<script setup>
import { ref } from "vue";
import emailjs from "@emailjs/browser";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";

const fullName = ref("");
const title = ref("");
const email = ref("");
const subject = ref("");
const description = ref("");
const file = ref(null);
const myMap = ref("");
const contactForm = ref(null);
const center = ref({ lat: 23.762831295321217, lng: 90.3557847625456 });
const markerOptions = ref({
  position: center,
  label: "P",
  title: "Penpencil.com",
});
const showSpinner = ref(false);
const errorMessage = ref({
  fullName: "",
//   title: "",
  email: "",
  subject: "",
  description: "",
});

const clearValidations = () => {
  Object.keys(errorMessage.value).forEach((key) => {
    errorMessage.value[key] = "";
  });
};

const validate = () => {
  clearValidations();
  let isValid = true;

  if (!fullName.value.trim()) {
    errorMessage.value.fullName = "Please give your name";
    isValid = false;
  }
  if (!email.value.trim()) {
    errorMessage.value.email = "Please give your email";
    isValid = false;
  } else if (!email.value.match(/\S+@\S+\.\S+/)) {
    errorMessage.value.email = "Please give a valid email";
    isValid = false;
  }
  if (!subject.value.trim()) {
    errorMessage.value.subject = "Please select a subject";
    isValid = false;
  }
  if (!description.value.trim()) {
    errorMessage.value.description = "Please enter a message";
    isValid = false;
  }
  return isValid;
};

const onFileChange = (e) => {
  file.value = e.target.files[0];
};

const sendEmail = (e) => {
    console.log("Sending email 1...");
  if (!validate()) return;
    console.log("Sending email 2...");
    
  showSpinner.value = true;
  emailjs
    .sendForm(
      "service_xwk2v2p",
      "template_01x4ws9",
      e.target,
    // contactForm.value,
      "7UX5nlr36MVhAXqAO"
    )
    .then(
    //   () => {
    //     alert("Mail Sent Successfully");
    //     fullName.value = "";
    //     email.value = "";
    //     title.value = "";
    //     // subject.value = "";
    //     description.value = "";
    //     // file.value = null;
    //   },
    //   () => {
    //     alert("Mail Failed to Send");
    //   }
        (result) => {
            console.log("SUCCESS!", result.text);
                fullName.value = "";
                email.value = "";
                title.value = "";
                description.value = "";
            // notyf.success("Mail Sent Successfully");
        },
        (error) => {
            console.log("FAILED...", error.text);
            // notyf.error("Mail Failed to Sent");
        }
    )
    .finally(() => {
      showSpinner.value = false;
    });
};
</script>

<style scoped>
/* Center wrapper */
#wrapper {
    min-height: 100vh;
    background: #f8f9fa;
}
</style>
